export const ActionType = {
  Hydrate: 'notes/hydrate',
  Create: 'notes/create',
  Move: 'notes/move',
  Resize: 'notes/resize',
  Delete: 'notes/delete',
  UpdateText: 'notes/updateText',
  UpdateColor: 'notes/updateColor',
  BringToFront: 'notes/bringToFront',
  ReconcileFromServer: 'notes/reconcileFromServer',
  RollbackOptimistic: 'notes/rollbackOptimistic',
  Undo: 'history/undo',
  Redo: 'history/redo',
} as const;

export type ActionType = (typeof ActionType)[keyof typeof ActionType];
